// Belongs to Interview Round Entity
export const InterviewRoundStatusEnum = Object.freeze({
  PendingSlotProposal: 0,
  SlotsProposed: 1,
  SlotSelected: 2,
  Completed: 3,
  Cancelled: 4,
  Skipped: 5,
});

export const InterviewRoundStatusLabel = Object.freeze({
  [InterviewRoundStatusEnum.PendingSlotProposal]: "Pending Slot Proposal",
  [InterviewRoundStatusEnum.SlotsProposed]: "Slots Proposed",
  [InterviewRoundStatusEnum.SlotSelected]: "Slot Selected",
  [InterviewRoundStatusEnum.Completed]: "Completed",
  [InterviewRoundStatusEnum.Cancelled]: "Cancelled",
  [InterviewRoundStatusEnum.Skipped]: "Skipped",
});

export const InterviewRoundStatusColor = Object.freeze({
  [InterviewRoundStatusEnum.PendingSlotProposal]: "#faad14",
  [InterviewRoundStatusEnum.SlotsProposed]: "#1677ff",
  [InterviewRoundStatusEnum.SlotSelected]: "#722ed1",
  [InterviewRoundStatusEnum.Completed]: "#52c41a",
  [InterviewRoundStatusEnum.Cancelled]: "#ff4d4f",
  [InterviewRoundStatusEnum.Skipped]: "#8c8c8c",
});